import { Outlet } from "react-router-dom"

export function TestLayout() {
  return (
    <div className="min-h-screen bg-background">
      <Outlet />
    </div>
  )
}
